module.exports = __webpack_public_path__ + "img/icon-soc.53656c56.svg";